export default "__VITE_ASSET__0e9077d0__"